export const GET_UNPAID_CASH_LIST_START =
  'GET_UNPAID_CASH_LIST_START';
export const GET_UNPAID_CASH_LIST_ERROR =
  'GET_UNPAID_CASH_LIST_ERROR';
export const GET_UNPAID_CASH_LIST_SUCCESS =
  'GET_UNPAID_CASH_LIST_SUCCESS';
